import { last } from 'lodash';
import create from 'zustand';
import { devtools } from 'zustand/middleware';

import { SkillDiscoveryItem as Item } from '@gmm/sdk-voodoo/skillDiscovery';
import { getIdentifier } from '~/work/skillDiscovery/utils';

interface SelectedItemState {
  selectedAncestors: Item[];
  getSelectedItem: () => Item | null;
  isSelected: (item: Item | null) => boolean;
  setSelectedAncestors: (
    ancestors: Item[] | ((prev: Item[]) => Item[]),
  ) => void;
}

export const useSelectedItemStore = create<SelectedItemState>()(
  devtools(
    (set, get) => ({
      selectedAncestors: [],

      getSelectedItem: (): Item | null => {
        const ancestors = get().selectedAncestors;
        return last(ancestors) ?? null;
      },

      isSelected: (item: Item | null) => {
        if (!item) return false;
        const selectedItem = get().getSelectedItem();
        return selectedItem
          ? getIdentifier(selectedItem) === getIdentifier(item)
          : false;
      },

      setSelectedAncestors: ancestors => {
        set(state => {
          const newAncestors =
            typeof ancestors === 'function'
              ? ancestors(state.selectedAncestors)
              : ancestors;
          return {
            selectedAncestors: newAncestors,
          };
        });
      },
    }),
    { name: 'SelectedItemStore' },
  ),
);
